import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const statHandleCodeLocaleModule: LocaleModule = {
  name: "statHandleCode",
  messages: { en: en, it: it },
};
